import { render, staticRenderFns } from "./registrationList.vue?vue&type=template&id=774760be&scoped=true"
import script from "./registrationList.vue?vue&type=script&lang=js"
export * from "./registrationList.vue?vue&type=script&lang=js"
import style0 from "./registrationList.vue?vue&type=style&index=0&id=774760be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774760be",
  null
  
)

export default component.exports